export default [
  {
    name: '李丰',
    title: `峰瑞资本
创始合伙人`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/lifeng.jpg',
  },
  {
    name: '钱炜',
    title: `李宁公司
执行董事
联席行政总裁`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/qianwei.jpg',
  },
  {
    name: '吴克群',
    title: `知名创作歌手
演员 & 导演`,
       avatar:
       'https://imgcdn.lanxiongsports.com/jnh20/wukequn.jpg',
   },
   
  {
    name: '邓厚鋆',
    title: `复娱文化
总裁`,
    avatar: 'https://imgcdn.lanxiongsports.com/jnh20/denghouyun.jpg',
  },
    {
    name: '喻凌霄',
    title: `爱奇艺体育
CEO`,
    avatar: 'https://imgcdn.lanxiongsports.com/jnh20/yulingxiao.jpg',
  },
  {
    name: '李胜',
    title: `盛力世家
创始人 & CEO`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/lisheng.jpg',
  },
  
  {
    name: '杨东为',
    title: `中信资本私募基金
运营合伙人`,
    avatar: 'https://imgcdn.lanxiongsports.com/jnh20/yangdongwei.jpg',
  },
  {
    name: '傅忠红',
    title: `达晨财智
主管合伙人`,
       avatar:
       'https://imgcdn.lanxiongsports.com/jnh20/fuzhonghong.jpg',
   },

 {
    name: '李莹/Echo Li',
    title: `SPORTFIVE | 拉加代尔
大中华区董事总经理
全球高级副总裁`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/liying.jpg',
  },
  {
    name: '穆旸',
    title: `阿里体育
COO`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/muyang.jpg',
  },
  
   {
    name: '董铮',
    title: `中超公司
总经理`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/dongzheng.jpg',
  },
  
  {
    name: '史凡',
    title: `Kappa中国
品牌市场体系副总裁`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/shifan.jpg',
  },
  
  {
    name: '祁冬',
    title: `MLB中国区
董事总经理`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/qidong.jpg',
  },
  {
    name: '王亭亭',
    title: `迪卡侬中国
副总裁`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/wangtingting.jpg',
  },
    {
    name: '付强',
    title: `FITURE
联合创始人 & CTO`,
    avatar: 'https://imgcdn.lanxiongsports.com/jnh20/fuqiang.jpg',
  },
  {
    name: '李天驰',
    title: `编程猫
创始人 & CEO`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/litianchi.jpg',
  },
  {
    name: 'Uki/张壬坤',
    title: `元气森林合伙人
功能性产品业务负责人`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/Uki.jpg',
  },
  {
    name: '戴富祺',
    title: `洛克公园创始人
& 洛合体育董事长`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/daifuqi.jpg',
  },
  {
    name: '益晓晓',
    title: `德国菲斯曼
亚太区市场总监`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/yixiaoxiao.jpg',
  },
  
  {
    name: '杨云',
    title: `韶音科技
大中华区营销总监`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/yangyun.jpg',
  },
  
  {
    name: '王锋',
    title: `中体数据·练多多
董事长`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/wangfeng.jpg',
  },
  {
    name: '伊力',
    title: `融创文旅集团
冰雪中心总经理`,
    avatar: 'https://imgcdn.lanxiongsports.com/jnh20/yili.jpg',
  },
  
  {
    name: '周寅猛',
    title: `深潜DeepDive
CEO`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/zhouyinmeng.jpg',
  },
  {
    name: '杨威',
    title: `体操奥运冠军
杨我国威运动俱乐部
创始人`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/yangwei.jpg',
  },
  {
    name: '陈鹏吉',
    title: `花香盛世
创始人 & CEO`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/chenpengji.jpg',
  },
    {
    name: '孙岭峰',
    title: `强棒创始人
强棒天使发起人`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/sunlingfeng.jpg',
  },
  
  {
    name: '祁楚尧',
    title: `爱动
合伙人`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/qichuyao.jpg',
  },
    
  {
    name: '王伟伟',
    title: `舒华体育
品牌总监`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/wangweiwei.jpg',
  },
  
  {
    name: '于一',
    title: `昂立慧动体育
创始人 & CEO`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/yuyi.jpg',
  },
  
  {
    name: '张天',
    title: `深潜DeepDive
CFO`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/zhangtian.jpg',
  },
  
  {
    name: '荆超',
    title: `魔盒M.BOX创始人
上海市产业转型研究院
首席策划师`,
    avatar:
      'https://imgcdn.lanxiongsports.com/jnh20/jingchao.jpg',
  },
  {
    name: '吴婷',
    title: `嘉宾大学
创办人`,
    avatar: 'https://imgcdn.lanxiongsports.com/jnh20/wuting.jpg',
  },
 {
    name: '刘语熙',
    title: '著名主持人',
    avatar: 'https://imgcdn.lanxiongsports.com/jnh20/liuyuxi.jpg',
  },
  
  {
    name: '鲍春来',
    title: '羽毛球世界冠军',
    avatar: 'https://imgcdn.lanxiongsports.com/jnh20/baochunlai.jpg',
  },
  {
    name: '董砾',
    title: `壹球ONEBALL
创始人`,
    avatar: 'https://imgcdn.lanxiongsports.com/jnh20/dongli.jpg',
  },
  
  {
    name: '娄一晨',
    title: '著名解说员',
    avatar: 'https://imgcdn.lanxiongsports.com/jnh20/louyichen.jpg',
  },
  
  {
    name: '何川',
    title: `民间登山家
中国登上布达拉峰
北壁第一人`,
    avatar: 'https://imgcdn.lanxiongsports.com/jnh20/hechuan.jpg',
  },
  
  {
    name: '孙吉',
    title: `足球运动员
上海吉祥足球运动
俱乐部总顾问`,
    avatar: 'https://imgcdn.lanxiongsports.com/jnh20/sunji.jpg',
  },
  {
    name: '韩牧',
    title: `懒熊体育
创始人 & CEO`,
    avatar: 'https://imgcdn.lanxiongsports.com/jnh20/hanmu.jpg',
  },
// {
//    name: '黎双富',
//    title: `懒熊体育
//联合创始人 & 总裁`,
//    avatar:
//      'https://imgcdn.lanxiongsports.com/jnh20/lishuangfu.jpg',
//  },

];
